export default "__VITE_PUBLIC_ASSET__e14624ff__"